// Push Notifications JavaScript functionality
$(document).ready(function() {
  const targetScreenSelect = $('#target_screen_select');
  const targetSelectionContainer = $('#target_selection_container');
  const targetSearch = $('#target_search');
  const searchResults = $('#search_results');
  const targetIdField = $('#target_id_field');
  const targetNameField = $('#target_name_field');
  const selectedTargetInfo = $('#selected_target_info');
  const selectedTargetDisplay = $('#selected_target_display');
  const clearSelectionBtn = $('#clear_selection');

  let searchTimeout;
  let currentScreenType = null;

  // Show/hide target selection based on screen choice
  targetScreenSelect.on('change', function() {
    const selectedScreen = $(this).val();
    
    if (selectedScreen === 'HomeScreen' || selectedScreen === '') {
      targetSelectionContainer.hide();
      clearTargetSelection();
    } else {
      targetSelectionContainer.show();
      currentScreenType = selectedScreen;
      updateSearchPlaceholder();
    }
  });

  // Update search placeholder based on screen type
  function updateSearchPlaceholder() {
    const placeholders = {
      'PartnerScreen': 'Search partners...',
      'EventScreen': 'Search events...',
      'PlaceScreen': 'Search places...',
      'RecurringEventScreen': 'Search recurring events...',
      'FarmersMarketScreen': 'Search farmers markets...',
      'WalkScreen': 'Search walks...',
      'SpecialScreen': 'Search special offers...'
    };
    
    targetSearch.attr('placeholder', placeholders[currentScreenType] || 'Start typing to search...');
  }

  // Handle search input
  targetSearch.on('input', function() {
    const query = $(this).val().trim();
    
    clearTimeout(searchTimeout);
    
    if (query.length < 2) {
      searchResults.hide();
      return;
    }

    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  // Perform search via AJAX
  function performSearch(query) {
    if (!currentScreenType) return;

    $.ajax({
      url: '/admin/push_notifications/search',
      method: 'GET',
      data: {
        screen_type: currentScreenType,
        query: query
      },
      success: function(data) {
        displaySearchResults(data);
      },
      error: function() {
        searchResults.html('<div class="list-group-item text-danger">Error searching. Please try again.</div>').show();
      }
    });
  }

  // Display search results
  function displaySearchResults(results) {
    if (results.length === 0) {
      searchResults.html('<div class="list-group-item text-muted">No results found</div>').show();
      return;
    }

    const html = results.map(item => `
      <div class="list-group-item list-group-item-action search-result-item" 
           data-id="${item.id}" 
           data-name="${item.name}">
        <strong>${item.name}</strong>
        ${item.description ? `<br><small class="text-muted">${item.description}</small>` : ''}
      </div>
    `).join('');

    searchResults.html(html).show();

    // Handle result selection
    $('.search-result-item').on('click', function() {
      const id = $(this).data('id');
      const name = $(this).data('name');
      
      selectTarget(id, name);
    });
  }

  // Select a target
  function selectTarget(id, name) {
    targetIdField.val(id);
    targetNameField.val(name);
    selectedTargetDisplay.text(name);
    selectedTargetInfo.show();
    
    targetSearch.val('');
    searchResults.hide();
  }

  // Clear target selection
  function clearTargetSelection() {
    targetIdField.val('');
    targetNameField.val('');
    selectedTargetInfo.hide();
    targetSearch.val('');
    searchResults.hide();
  }

  // Clear selection button
  clearSelectionBtn.on('click', function() {
    clearTargetSelection();
  });

  // Hide search results when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('#target_selection_container').length) {
      searchResults.hide();
    }
  });

  // Initialize based on existing values
  if (targetScreenSelect.val() && targetScreenSelect.val() !== 'HomeScreen') {
    targetSelectionContainer.show();
    currentScreenType = targetScreenSelect.val();
    updateSearchPlaceholder();
    
    if (targetIdField.val() && targetNameField.val()) {
      selectedTargetDisplay.text(targetNameField.val());
      selectedTargetInfo.show();
    }
  }
});
